import React from 'react'
import { NextPage } from 'next'
import styled from 'styled-components'
import dynamic from 'next/dynamic'
import { captureException } from '@sentry/nextjs'
import { createResource, useResource } from '../lib/i18n'
import Link from 'next/link'
import Head from 'next/head'
const Footer = dynamic(import('@/components/home/footer'))
const TopNavigation = dynamic(import('@/components/top-navigation'))

const resource = createResource({
  en: {
    statusCode: {
      '400': 'Bad Request',
      '401': 'Unauthorized',
      '402': 'Payment Required',
      '403': 'Forbidden',
      '404': 'Not Found',
    },
    gohome: 'Go to home',
  },
  id: {
    statusCode: {
      '400': 'Bad Request',
      '401': 'Unauthorized',
      '402': 'Payment Required',
      '403': 'Forbidden',
      '404': '404 Halaman yang Kamu cari, tidak tersedia.',
    },
    gohome: 'Kembali ke halaman utama',
  },
})

const ErrorBody = styled.div`
  height: 100vh;
  background: white;
  .error {
    width: 100vw;
    margin: 0 auto 15%;
    padding-top: 20%;
    h2 {
      font-size: 48px;
      line-height: 2;
    }

    .error-code {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 12px;
      .message {
        margin-left: 30px;
      }
    }

    .go-home {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .green {
      color: #1cc812;
      margin-left: 16px;
    }
  }
`

const Error: NextPage<{ statusCode?: number | null; message?: string | null }> = ({ statusCode, message }) => {
  const { t } = useResource(resource)
  const statusCodeMap = t('statusCode', { returnObjects: true })
  const gohome = t('gohome')
  const codeMessage: string | undefined = statusCode ? (statusCodeMap as any)[statusCode.toString()] : undefined
  return (
    <>
      <Head>
        <meta name="robots" content="noindex" />
      </Head>
      <ErrorBody>
        <TopNavigation />
        <section className="error">
          <div className="error-code">
            <h2>{statusCode}</h2>
            <div className="message">
              {codeMessage ? codeMessage : message ? message : 'An error occurred on client'}
            </div>
          </div>
          <div className="go-home">
            <Link href={`/`}>
              <a className="green">
                <span>{gohome}</span>
              </a>
            </Link>
          </div>
        </section>
        <Footer />
      </ErrorBody>
    </>
  )
}

Error.getInitialProps = async ({ res, err }) => {
  const message = res ? res.statusMessage : err ? err.message : null
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404
  console.log('error code ====> ', statusCode)
  captureException(err)
  if (statusCode === 500) {
    res.writeHead(301, { Location: '/' })
    res.end()
  }
  return { statusCode, message }
}

export default Error
